import { render, staticRenderFns } from "./PageGradient.vue?vue&type=template&id=ef4efe60&scoped=true&"
import script from "./PageGradient.vue?vue&type=script&lang=js&"
export * from "./PageGradient.vue?vue&type=script&lang=js&"
import style1 from "./PageGradient.vue?vue&type=style&index=1&id=ef4efe60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4efe60",
  null
  
)

export default component.exports